import './crfTable.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleMinus, faCirclePlus } from '@fortawesome/free-solid-svg-icons';

import CrfDocLink from '../Layouts/CrfDocLink/crfDocLink';
import CdeDetailsLink from '../Layouts/CdeDetailsLink/cdeDetailsLink';

const CrfTable = ({ domain, subDomain, crfs, isExpanded, toggleExpanded, diseaseId }) => {
    return (
        <table className="crf-table">
            <caption className="crf-table-caption" onClick={() => toggleExpanded(`${domain.domainId}_${subDomain.subDomainId}`)}>
                <FontAwesomeIcon className="crf-table-caption-icon" icon={isExpanded ? faCircleMinus : faCirclePlus} />
                {subDomain.subDomainName}
            </caption>
            <thead className="crf-table-header" style={{ display: isExpanded ? null : 'none' }}>
                <tr>
                    <th>CRF Module / Guideline</th>
                    <th>CDEs</th>
                </tr>
            </thead>
            <tbody className="crf-table-body" style={{ display: isExpanded ? null : 'none' }}>
                {crfs.map(crf => (
                    <tr key={`${domain.domainId}_${subDomain.subDomainId}_${crf.crfId}`}>
                        <td className="crf-name">
                            <CrfDocLink
                                crfExtension={crf.crfExtension}
                                crfId={crf.crfId}
                                crfName={crf.crfName}
                                externalUrl={crf.externalUrl}
                            />
                        </td>
                        <td>
                            <CdeDetailsLink
                                associatedCDE={crf.associatedCDE}
                                crfId={crf.crfId}
                                crfName={crf.crfName}
                                domainName={crf.domainName}
                                reportType="CRF"
                                subDomainName={crf.subDomainName}
                                diseaseId={diseaseId}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default CrfTable;